import { env } from './env.constants';

export const API_URL = env.REACT_APP_API_URL || 'http://localhost:3000/v1';
export const API_KEY = env.REACT_APP_API_KEY || 'AIzaSyBrf78w0mZ5AhrctAJoqInN1XYHUvxBKig';

export const API_HISTORY_URL = env.REACT_APP_API_HISTORY_URL;
